import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers";

// Create the Redux store
const store = configureStore({
  reducer: rootReducer, // The combined reducer that represents the state tree of application
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools in non-production environments
});
 
export default store;